module.exports = __webpack_public_path__ + "img/twitter_blackandwhite.d447667.png";